export interface IPopupErrorModel {
    errorType: ErrorTypes;
    customErrorText: string;
}

export enum ErrorTypes {
    NONE,
    GENERAL,
    TIMEOUT
}




// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/global/state-helpers/popup-error.ts